import {
  AggInputData,
  AggregatedFactors,
  AggHomogenizationData,
  FactorData,
  FactorsScoresData,
} from '@/api/workOrders/types';

import { isFilled } from '../../utils/completionUtils';

export const isHomogenizationComplete = (factorsData: FactorData[]): boolean =>
  factorsData.length > 0 &&
  factorsData.every(
    (factor) =>
      isFilled(factor.input_data.offer) &&
      (factor.input_data.offer === 'transacionado' ||
        isFilled(factor.input_data.offer_factor)) &&
      (factor.columns?.length ?? 0) > 0 &&
      factor.columns?.every((col) => isFilled(col.homo_value)) === true
  );

export const isFactorsComplete = (
  factorsData: FactorData[],
  aggregatedFactors: AggregatedFactors[]
): boolean =>
  factorsData.length > 0 &&
  factorsData.every(
    (factor) =>
      (factor.columns?.length ?? 0) > 0 &&
      factor.columns?.every((col) => isFilled(col.value)) === true &&
      isFilled(factor.homogenized_price) &&
      isFilled(factor.sanitized_price) &&
      isFilled(factor.admissible_adj_interval)
  ) &&
  aggregatedFactors.length > 0 &&
  aggregatedFactors.every(
    (factor) =>
      isFilled(factor.mean_ppsm) &&
      isFilled(factor.std_ppsm) &&
      isFilled(factor.coeff)
  );

export const isVariationComplete = (variationAgg: AggInputData): boolean =>
  isFilled(variationAgg.mean_total_price) &&
  isFilled(variationAgg.mean_ppsm) &&
  isFilled(variationAgg.mean_ppsm_with_offer) &&
  isFilled(variationAgg.std_ppsm) &&
  isFilled(variationAgg.std_ppsm_with_offer) &&
  isFilled(variationAgg.coeff_ppsm);

export const isAggHomogenizationComplete = (
  aggregated: AggHomogenizationData
): boolean =>
  isFilled(aggregated.homogenized_elements) &&
  isFilled(aggregated.homogenized_lower_mean) &&
  isFilled(aggregated.homogenized_upper_mean) &&
  isFilled(aggregated.homogenized_mean);

export const isAggSanitizationComplete = (
  aggregated: AggHomogenizationData
): boolean =>
  isFilled(aggregated.sanitized_elements) &&
  isFilled(aggregated.sanitized_mean) &&
  isFilled(aggregated.sanitized_std) &&
  isFilled(aggregated.sanitized_lower_mean) &&
  isFilled(aggregated.sanitized_upper_mean) &&
  isFilled(aggregated.t_student) &&
  isFilled(aggregated.upper_limit) &&
  isFilled(aggregated.lower_limit) &&
  isFilled(aggregated.confidence_interval);

export const isResultValueFormationComplete = (
  aggregated: AggHomogenizationData
): boolean =>
  isFilled(aggregated.area) &&
  isFilled(aggregated.market_value_rounded_1pct_plus) &&
  isFilled(aggregated.market_value_rounded_1pct_minus) &&
  isFilled(aggregated.rounded_market_value);

export const isScoresFundamentationComplete = (
  scores: FactorsScoresData
): boolean =>
  scores.items.length === 4 &&
  scores.items.every((item) => isFilled(item.points));

export const isScoresDegreesComplete = (scores: FactorsScoresData): boolean =>
  isFilled(scores.reasoning_level);

export const isScoresPrecisionComplete = (
  aggregated: AggHomogenizationData
): boolean => isFilled(aggregated.precision_level);

export const isEvaluationResultComplete = (
  aggregated: AggHomogenizationData
): boolean =>
  isFilled(aggregated.market_value) &&
  isFilled(aggregated.lower_limit_total) &&
  isFilled(aggregated.upper_limit_total) &&
  isFilled(aggregated.lower_limit_confidence) &&
  isFilled(aggregated.upper_limit_confidence);
